import { takeLatest, call, put } from 'redux-saga/effects';
import { GatewayManagementApi } from 'api';
import { apiCallStatus, NOTIFICATION_TYPES } from 'helpers/constants';
import logger from 'helpers/logger';
import { actionTypes } from './constants';
import { actionTypes as connectedAssetsActionTypes } from '../../../constants';
import { disconnectEnvironmentSensorAction } from './actions';
import { notify } from 'sharedComponents/GeneralNotification';

function* disconnectEnvironmentSensor({ gatewayID }) {
    yield put(disconnectEnvironmentSensorAction(apiCallStatus.LOADING));
    try {
        const response = yield call(GatewayManagementApi.disconnectEnvironmentSensor, gatewayID);
        yield put(disconnectEnvironmentSensorAction(apiCallStatus.SUCCESS, response));
        if (response?.errorMessage) {
            notify(response.errorMessage, NOTIFICATION_TYPES.ERROR, true);
        }
        yield put({
            type: connectedAssetsActionTypes.GET_GATEWAY_CONNECTED_ASSETS,
            payload: { gatewayID: gatewayID }
        });
        logger.debug('Disconnect Environment Sensor successfully triggered for gateway ', gatewayID);
    } catch (err) {
        yield put(disconnectEnvironmentSensorAction(apiCallStatus.ERROR, [], err));
        notify(err?.message, NOTIFICATION_TYPES.ERROR, true);
    }
}
export function* disconnectEnvironmentSensorWatchers() {
    yield takeLatest(actionTypes.DISCONNECT_ENVIRONMENT_SENSOR, disconnectEnvironmentSensor);
}
